"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTH_STORAGE_USER = exports.AUTH_STORAGE_TOKEN = void 0;
const AUTH_STORAGE_TOKEN = exports.AUTH_STORAGE_TOKEN = "auth.token";
const AUTH_STORAGE_USER = exports.AUTH_STORAGE_USER = "auth.user";